var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutboundFilled = function SvgOutboundFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.59 14.74 10.91-6.3c.17-.1.26-.27.26-.45s-.09-.35-.26-.45L3.59 1.26c-.41-.24-.9.16-.75.61l1.04 3.08-2.33 2.32a1.04 1.04 0 0 0 0 1.46l2.33 2.32-1.04 3.08c-.15.45.33.85.75.61M10.25 8l-4.97 2.04L3.24 8l2.04-2.04z"
  })));
};
export default SvgOutboundFilled;